import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers } from '@angular/http';

import { Observable } from 'rxjs';

import { RequestService } from './request.service';
import { ConfigService } from './config.service';

declare var Evaporate: any;

@Injectable()
export class UploadService {

    private evaporate: any;

    constructor(private requestService: RequestService,
        private http: Http,
        private configService: ConfigService) { }

    getPreSignedToken(file: File): Observable<any> {
        let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.upload.presigned.api;

        let body = {
            name: file.name,
            type: file.type,
            size: file.size,
            component: 'branded-portal'
        };

        return this.requestService.post(url, body);
    }

    uploadContent(content: File, name: string): Observable<any> {
        return Observable.create((observer: any) => {
            let signerUrl: string = this.configService.get('server').sahara + this.configService.get('routes').sahara.signature;

            let output = {
                completed: false,
                progress: 0,
                error: null
            };

            this.evaporate = new Evaporate({
                signerUrl: signerUrl,
                aws_key: this.configService.get('aws').key,
                bucket: this.configService.get('aws').uploadsBucket,
                aws_url: this.configService.get('aws').url
            });

            this.evaporate.add({
                name: name,
                file: content,
                xAmzHeadersAtInitiate: {
                    'x-amz-acl': 'public-read'
                },
                started: function (uploadId) {
                    observer.next(output);
                },
                complete: function (r) {
                    output.completed = true;
                    observer.next(output);
                    observer.complete();
                },
                progress: function (progress: number) {
                    output.progress = Math.floor(progress * 100);
                    observer.next(output);
                },
                error: function (error: string) {
                    output.error = error;
                    observer.next(output);
                    observer.complete();
                }
            });
        })
        .flatMap(res => res.error ? Observable.throw(res.error) : Observable.of(res))
        .filter(res => res.completed);
    }

    completeFileDetails(id: string) {
        let url = this.configService.get('server').brandedApiUrl + this.configService.get('endpoints').solar.upload.complete.api + '/' + id;
        return this.requestService.post(url, {});
    }
}


// WEBPACK FOOTER //
// ./src/app/core/services/upload.service.ts